import React, { useEffect, useState } from 'react';
import gradeIcon from '../../../assets/Imagess/Contact/gradeIcon.svg';
import gpaIcon from '../../../assets/Imagess/Contact/gpaIcon.svg';
import houseicon from '../../../assets/Imagess/Contact/houseIcon.svg';
import blockIcon from '../../../assets/Imagess/Campaign/blockIcon.svg';
import unblockICon from '../../../assets/Imagess/Campaign/unblockIcon.svg';
import notesIcon from '../../../assets/Imagess/notesIcon.svg';
import logsIcon from '../../../assets/Imagess/logsIcon.svg';
import campaignsIncludedIcon from '../../../assets/Imagess/Contact/campaignsIncludedIcon.svg';
import detailsIcon from '../../../assets/Imagess/inACtiveOnlineIcon.svg';
import receivedEmailIcon from '../../../assets/Imagess/Contact/campaignemailReceived.svg';
import SingleApplicantTopHeader from '../../Moecules/SingleApplicant/SingleApplicantTopHeader';
import WrappingContainer from '../../HOC/WrappingContainer/WrappingContainer';
import SingleTabGroup from '../../Moecules/SingleApplicant/SingleTabGroup';
import CampaignsIncluded from '../../Moecules/Settings/ContactDetails/CampaignsIncluded/CampaignsIncluded';
import EmailsReceivedContainer from '../../Moecules/Settings/ContactDetails/EmailsReceived/EmailsReceivedContainer';
import DeletePopup from '../../Moecules/Custom/DeletePopup';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useBlockUnblockExternalContact,
  useFetchExternalContactById,
} from '../../../Hooks/Externalcontact';
import { toast } from 'react-toastify';
import Loader from '../../Moecules/Loader/Loader';
import NotesContainer from '../../Moecules/Applicants/Notes/NotesContainer';
import ApplicantLogs from '../../Moecules/Applicants/ApplicantLogs/ApplicantLogs';
import DetailsTab from '../../Moecules/Settings/ContactDetails/details/DetailsTab';
import sendEmailICon from '../../../assets/Imagess/sendemailicon.svg';
import EmailModal from '../../Moecules/Settings/SettingsModal/EmailModal';
import editIcon from '../../../assets/Imagess/Edit (1).svg';

const SingleExternalContactPage = () => {
  const params = useParams();
  const { id } = params;
  const navigate = useNavigate();

  const [selected, setSelected] = useState(0);
  const [isBlock, setIsBlock] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState([]);

  const {
    data: contactDetails,
    refetch,
    isLoading: isLoadingExternalContactById,
  } = useFetchExternalContactById({ id });
  const data = contactDetails?.data;

  const { mutate: blockUnblock, isLoading: isBlockingContact } =
    useBlockUnblockExternalContact();

  const bottomLeftComponent = [
    {
      icon: houseicon,
      text: data?.externalContact?.schoolName ?? '-',
    },
    ...(data?.externalContact?.contactTypeName === 'School Student'
      ? [
          {
            icon: gradeIcon,
            text: 'Grade ' + (data?.externalContact?.gradeName ?? '-'),
          },
          {
            icon: gpaIcon,
            text: 'GPA ' + (data?.externalContact?.highSchoolGPA ?? '-'),
          },
        ]
      : []),
  ];

  const tabContainer = [
    {
      text: 'Details',
      value: 0,
      icon: detailsIcon,
    },
    {
      text: 'Campaigns Included',
      value: 2,
      icon: campaignsIncludedIcon,
    },
    {
      text: 'Emails',
      value: 3,
      icon: receivedEmailIcon,
    },
    {
      text: 'Notes',
      value: 4,
      icon: notesIcon,
    },

    {
      text: 'Contact Log',
      value: 5,
      icon: logsIcon,
    },
  ];
  const handleOpenEmailModal = () => {
    setShowEmailModal(true);
    setSelectedContact([{ id: id }]);
  };

  const handleBlockUnBLock = () => {
    blockUnblock(
      {
        contactId: data?.externalContact?.externalContactId,
        isBlock: !data?.externalContact?.isBlocked,
      },
      {
        onSuccess: () => {
          refetch();
          toast.success(
            data?.externalContact?.isBlocked
              ? 'Activated Contact'
              : 'Deactivated Contact',
          );
          setIsBlock(false);
        },
      },
    );
  };

  useEffect(() => {
    refetch({ id });
  }, [id]);

  return (
    <>
      <WrappingContainer>
        <SingleApplicantTopHeader
          bottomLeftComponent={bottomLeftComponent}
          rightComponent={[
            {
              icon: data?.externalContact?.isBlocked ? unblockICon : blockIcon,
              text: data?.externalContact?.isBlocked
                ? 'Activate User'
                : 'Deactivate User',
              handleFunction: () => setIsBlock(!isBlock),
            },
            {
              icon: sendEmailICon,
              text: 'Send Email',
              handleFunction: handleOpenEmailModal,
            },
            {
              icon: editIcon,
              handleFunction: () =>
                navigate(`/home/edit-externalContact/${id}`),
            },
          ]}
          data={{
            email: data?.externalContact?.email,
            firstName: data?.externalContact?.contactName,
            mobile: data?.externalContact?.mobile,
          }}
          isLoading={isLoadingExternalContactById}
          isStudent={data?.externalContact?.contactTypeName == 'School Student'}
        />

        <SingleTabGroup
          tabContainer={tabContainer}
          selected={selected}
          setSelected={setSelected}
        />
        {isLoadingExternalContactById ? (
          <Loader />
        ) : selected === 0 ? (
          <DetailsTab data={data?.externalContact} />
        ) : selected === 2 ? (
          <CampaignsIncluded data={data?.campaigns} />
        ) : selected === 3 ? (
          <EmailsReceivedContainer mails={data?.allMail} />
        ) : selected === 5 ? (
          <ApplicantLogs logs={data?.logs} />
        ) : selected === 4 ? (
          <NotesContainer
            notes={data?.applicantNotes}
            id={id}
            refetch={refetch}
          />
        ) : null}
      </WrappingContainer>
      {isBlock && (
        <DeletePopup
          handleOnClose={() => setIsBlock(!isBlock)}
          mode={data?.externalContact?.isBlocked ? 'Activate' : 'Deactivate'}
          handleDelete={handleBlockUnBLock}
          text={
            data?.externalContact?.isBlocked
              ? 'Are you sure you want to activate this'
              : 'Are you sure you want to Deactivate this'
          }
          title='user'
          subText={
            data?.externalContact?.isBlocked
              ? 'User will be included in any campaign.'
              : 'User will not be included in any campaign.'
          }
          isLoading={isBlockingContact}
        />
      )}
      {showEmailModal && (
        <EmailModal
          handleOnClose={() => setShowEmailModal(false)}
          title='Send Email'
          selectedApplicants={selectedContact}
          setSelectedApplicants={setSelectedContact}
          refetchData={refetch}
          isExternalContact
        />
      )}
    </>
  );
};

export default SingleExternalContactPage;
